// extracted by mini-css-extract-plugin
module.exports = {"item":"_80ad21f8ef--item--A8h1z","item-title":"_80ad21f8ef--item-title--qrvDB","item-text":"_80ad21f8ef--item-text--rizxk","label":"_80ad21f8ef--label--DIPlv"};